import Breadcrumbs from './Breadcrumbs.js';

export default Breadcrumbs;
